import { twMerge } from 'tailwind-merge'

import { textColor } from '@nxt-insurance/ui-kit/styles/colors'

import type { SvgProps } from '@/components/renderers/MultiColoredImage/types'

const defaultWidth = 32
const defaultHeight = 32

export const Twitter = (props: SvgProps) => {
  const width = props.width ?? defaultWidth
  const height = props.height ?? defaultHeight
  return (
    <svg
      className={twMerge('block w-auto', textColor({ color: props.color }))}
      width={width}
      height={height}
      viewBox="0 0 32 32"
      preserveAspectRatio="none"
      color={props.color}
    >
      <g id="Components" stroke="none" strokeWidth="1" fillRule="evenodd">
        <g id="Social-Media-Icons" transform="translate(-983.000000, -514.000000)" />
        <path
          fill="currentColor"
          d="M22.362,12.737 C22.368,12.878 22.372,13.019 22.372,13.162 C22.372,17.499 19.07,22.501 13.032,22.501 C11.178,22.501 9.453,21.958 8,21.027 C8.257,21.057 8.518,21.072 8.783,21.072 C10.321,21.072 11.736,20.548 12.86,19.667 C11.423,19.641 10.211,18.692 9.793,17.388 C9.994,17.426 10.199,17.446 10.411,17.446 C10.71,17.446 11,17.406 11.276,17.331 C9.774,17.03 8.643,15.703 8.643,14.113 L8.643,14.071 C9.085,14.317 9.592,14.465 10.13,14.482 C9.249,13.893 8.669,12.888 8.669,11.75 C8.669,11.148 8.831,10.584 9.114,10.099 C10.733,12.085 13.152,13.392 15.88,13.529 C15.824,13.289 15.795,13.038 15.795,12.781 C15.795,10.968 17.265,9.498 19.077,9.498 C20.022,9.498 20.875,9.897 21.473,10.535 C22.221,10.388 22.924,10.115 23.558,9.739 C23.313,10.505 22.792,11.148 22.115,11.555 C22.779,11.475 23.411,11.299 24,11.038 C23.56,11.696 23.003,12.274 22.362,12.737 L22.362,12.737 Z M0,29.9982567 C0,31.103789 0.889261723,32 2.00174332,32 L29.9982567,32 C31.103789,32 32,31.1107383 32,29.9982567 L32,2.00174332 C32,0.89621101 31.1107383,0 29.9982567,0 L2.00174332,0 C0.89621101,0 0,0.889261723 0,2.00174332 L0,29.9982567 Z"
          id="Fill-93-Copy"
        />
      </g>
    </svg>
  )
}
